<template>
    <div class="top-container">
        <PwaDownloadCard @intallPWA="intallPWA" @isClosedPWA="isClosedPWA" />
        <van-row class="header" justify="space-between">
            <!-- sidenav Icon -->
            <van-col span="2" @click="openSidebar" class="header_item_menu">
                <img :src="sideIconData.url" alt="" v-if="sideIconData.display">
            </van-col>
            <!-- header logo -->
            <van-col :span="userStore.loginAccount ? 10 : 10" class="header_item_logo">
                <img :src="appIconData.url" alt="" v-if="appIconData.display">
            </van-col>
            <van-col v-if="userStore.loginAccount" style="display: flex; justify-content: right;" span="11"
                align="right">
                <!-- user balance -->
                <img v-if="userBalnceData.display" src="@/assets/themeFour/cash.png" alt="" width="25%">
                <div v-if="userBalnceData.display" class="header_button_item">
                    <div class="coin_btn">
                        <div style="padding-left: 5px;"><span style="">R$ </span>{{ formatCurrency(balance) }}</div>
                    </div>
                    <div class="balanceText">{{ $t('home.balance') }}</div>
                </div>

            </van-col>
            <!-- Login register buttons -->
            <van-col v-if="!userStore.loginAccount" span="11" class="header_button_item" align="center">
                <van-row style="width: 100%;">
                    <van-col span="11" class="btnContainer">
                        <img @click="openRegisterPopup(1)" src="@/assets/themeFour/btn2.png" alt="" width="100%"
                            height="100%">
                        <div class="registerLoginBtn"  @click="openRegisterPopup(1)">{{ $t('common.login') }}</div>
                    </van-col>

                    <van-col span="12" offset="1" class="btnContainer">
                        <img @click="openRegisterPopup(0)" src="@/assets/themeFour/btn1.png" alt="" height="100%"
                            width="100%">
                        <div class="registerLoginBtn"  @click="openRegisterPopup(0)">{{ $t('common.register') }}</div>
                    </van-col>
                </van-row>
            </van-col>
            <!-- Theme change popup icon -->
            <!-- <van-col :span="1" style="align-items: center;display: flex;">
                <img src="@/assets/theme/threeDot.png" height="15" width="15" @click="handleThemeChange">
            </van-col> -->
        </van-row>
        <!-- <ThemeChangePopup ref="themeChangeRef" /> -->
    </div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import SideNavbar from "../sideNav/sideNavbar.vue"
import { ref, inject, computed, onMounted } from 'vue';
import { playClickSound } from "@/utils/media";
import { useUserStore } from "@/stores/user";
import { formatCurrency } from "@/utils/commonFunction";
import PwaDownloadCard from "../../home/components/pwaDownloadCard.vue";
// import ThemeChangePopup from "./themeChangePopup.vue";
import ContactServicePopup from "@/view/profile/contactServicePopup.vue";
import { safeNavigate } from "@/view/home/supportScript";
const router = useRouter();
const openRegisterLoginPopup = inject<(type: number) => void>('openRegisterLoginPopup')
const sideNavbarRef = ref()
const themeChangeRef = ref()
const batchContent = ref(0)
const token = ref(localStorage.getItem('token'))
const isLogin = ref(token.value ? true : false)
const userStore = useUserStore()
const balance = computed(() => userStore.balance)
const unreadMsgCount = computed(() => userStore.unreadCount)
const isRotating = ref(false);
const props = defineProps<{
    itemData: {
        appIcon: {
            url: string,
            display: boolean
        },
        sideIcon: {
            url: string,
            display: boolean
        },
        userBalnce: {
            display: boolean
        },
        searchButton: {
            display: boolean,
        },
    },
    listGameData: {
        name: string,
        customIcon: string,
        id: number
    }[]
}>()
const appIconData = ref({
    url: props.itemData.appIcon.url,
    display: props.itemData.appIcon.display
})

const listGameData = computed(() => props.listGameData);
const sideIconData = ref({
    url: props.itemData.sideIcon.url,
    display: props.itemData.sideIcon.display,
})
const userBalnceData = ref({
    display: props.itemData.userBalnce.display,
})
const searchButtonData = ref({
    display: props.itemData.searchButton.display,
})
const openSidebar = () => {
    if (isRotating.value) return;

    playClickSound();
    isRotating.value = true;

    emits('openSidebar');

    setTimeout(() => {
        isRotating.value = false;
    }, 1000);
}
const openRegisterPopup = (type: number) => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') { return }
    openRegisterLoginPopup?.(type)
}
const emits = defineEmits(['goToProfile', 'intallPWA', 'isClosedPWA', 'goToGamePanel', 'goToGameSearch', 'openSidebar', 'goToDeposit'])
const goToMessage = (event: Event) => {
    safeNavigate(router, '/sd-message', event)
}
const goToGamePannelSidePannel = (id: number) => {
    emits('goToGamePanel', id)
}
const goToDeposit = () => {
    playClickSound()
    emits('goToDeposit')
}
const handleThemeChange = () => {
    themeChangeRef.value.open()
}
const goToGameSearch = () => {
    emits('goToGameSearch')
}

onMounted(() => {
    appIconData.value.url = props.itemData.appIcon.url
    appIconData.value.display = props.itemData.appIcon.display

    sideIconData.value.url = props.itemData.sideIcon.url
    sideIconData.value.display = props.itemData.sideIcon.display

    userBalnceData.value.display = props.itemData.userBalnce.display

})

const intallPWA = () => {
    emits('intallPWA');
}

const isClosedPWA = (value: any) => {
    emits('isClosedPWA', value);
}
</script>
<style scoped>
.header {
    /* top: 0; */
    z-index: 2000;
    width: 100%;
    position: fixed;
    left: 0;
    right: 0;
    display: flex;
    background: rgb(2, 74, 73);
    padding: 0;
    height: 60px;
}

.header_item_menu {
    display: flex;
    align-items: center;
    justify-content: left;
}

.header_item_menu>>>.van-badge {
    font-size: 9px;
    margin: 5px 5px 0 0;
    line-height: 1.5;
}

.header_back_icon {
    display: flex;
    background: rgba(255, 255, 255, 0.04);
    box-shadow: inset -1px 0 0 0 rgba(255, 255, 255, 0.04);
    align-items: center;
    justify-content: center;
    padding: 0 8px;
}

.header_item_menu img {
    width: 35px;
    padding: 8px 3px 8px 5px;
}

.header_back_icon img {
    width: 21px;
    height: 23px;
    transform: rotate(180deg);
}

.header_item_logo {
    display: flex;
    align-items: center;
    padding: 0;
}

.header_button_item {
    padding-right: 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
}


.header_item_logo img {
    width: 95%;
    /* padding-left: 2px; */
}

.footer_button_item img:first-child {
    width: 65px;
}

.footer_button_item img:nth-child(2) {
    width: 45px;
}

.login_btn {
    display: flex;
    align-items: center;
    justify-content: center;
}

.register_btn {
    display: flex;
    align-items: center;
    justify-content: center;
}

.van-button--small {
    height: 22px;
    width: 70px;
    border-radius: 5px;
}

.btnContainer {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.registerLoginBtn {
    position: absolute;
    top: 0;
    height: 100%;
    padding-top: 2%;
    font-size: 20px;
    font-weight: 600;
    color: #fff;
    align-items: center;
}

.registerLoginBtn:hover {
    background: rgba(255, 255, 255, 0.082);
}

.coin_btn {
    display: flex;
    justify-content: right;
    flex-direction: column;
    color: #fff;
    font-size: 17px;
    font-weight: 700;
    border-radius: 20px;
    margin-right: 1px;
    white-space: nowrap;
    overflow: hidden;
}


.coin_btn div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
}

.coin_btn img {
    width: 20px;
    padding: 0 5px;
}

.balanceText {
    color: rgba(255, 255, 255, 0.60);

}

.mail {
    position: relative;
}

.mail img {
    width: 40px;
}

.pig {
    position: relative;
}

.pig img {
    width: 50px;
}

.search_btn {
    display: inline-block;
}

.search_btn img {
    width: 100%;
    cursor: pointer;
}

.search_btn:hover {
    opacity: 0.5;
}

.more_img img {
    width: 12px;
    position: absolute;
    margin: 15px 0px 0px -12px;
}

.top-container {
    position: fixed;
    z-index: 1997;
    width: 100%;
    left: 0;
    right: 0;
    top: 0;
}

.moving-badge {
    position: absolute;
    top: 0;
    right: 0;
    animation: bounce 1.2s infinite ease-in-out;
    transform-origin: center;
    background-color: #ed0000;
    color: #fff;
    border-radius: 30px;
    padding: 3px;
    font-size: 11px;
}

.moving-badge::v-deep(.van-badge__wrapper) {
    animation: bounce 1.5s infinite ease-in-out;
    transform-origin: center;
}

.rotate-animation {
    animation: rotateBack 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

@media (max-width: 450px) {
    .coin_btn {
        font-size: 13px;
    }

    .registerLoginBtn {
        font-size: 16px;
    }

}

@keyframes rotateBack {
    0% {
        transform: rotate(0deg);
    }

    50% {
        transform: rotate(90deg);
    }

    100% {
        transform: rotate(0deg);
    }
}

/* Crucial: Vant icons need to be inline-block to rotate */
:deep(.van-icon-wap-nav) {
    display: inline-block !important;
}

@keyframes bounce {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-2.5px);
    }
}
</style>